// Recipe titles are shown in the display face at 40 px on the recipe page and
// the choices sheet. Imported ones can run to a sentence, so past this length
// they step down a size (styles/recipes.css `.is-long`).

export const LONG_TITLE = 32

export function isLongTitle(title: string): boolean {
  return title.trim().length > LONG_TITLE
}
